import * as React from 'react';
import { ComboBox } from '@mescius/wijmo.react.input';
import * as Wijmo from '@mescius/wijmo';
import * as WjInput from '@mescius/wijmo.input';
import * as ValidateUtil from '../common/ValidateUtil';

interface wjTextBoxProps{
    label?:string,
    id?:string,
    text?:string,
    inputType?:string,
    isReadOnly?:boolean,
    textChanged?:(target:WjInput.ComboBox<any> ,e:Wijmo.EventArgs) => void
} 
/**
 * テキストボックス
 * @param props 
 */
export const WjTextBox = (props:wjTextBoxProps) => {
    let isReadOnly = false;
    if(!ValidateUtil.IsUndefined(props.isReadOnly))
        isReadOnly = props.isReadOnly;

    return (
        <>
            <label className="input-label">{props.label}</label>
            <ComboBox 
                id={props.id}
                class="input-control"
                text={props.text}
                textChanged={props.textChanged}
                inputType={props.inputType}
                isReadOnly={isReadOnly}
                >
            </ComboBox>
        </>
    );
};
